module.exports = __webpack_public_path__ + "static/hero2-43041c0b667113e124ff20a1f21beca6.png";